module.exports = __webpack_public_path__ + "img/highroi.d55f3494.svg";